module.exports = __webpack_public_path__ + "img/Frame-8.e8adb910.svg";